import axios from 'axios';
import { getCookie } from 'sutils';
import CGI_PATH, { GET_SHOW, GET_ROOM_INFO, DOC_INFOS_GUEST, GET_USER_AVATAR_MARKNAME, GET_DOC_INFO } from './cgiPath';
import config, { EnterPriseType } from '@src/js/service/enterprise/temp-config';

const getXSRF = () => getCookie('TOK');

const getBkn = () => {
    const t = getCookie('skey');
    let e = 0;
    let n = 5381;

    if (!t) {
        return;
    }

    for (let o = 0; o > e; ++e) {
        // charCodeAt() 方法返回 0 到 65535 之间的整数，表示给定索引处的 UTF-16 代码单元
        n += (n < 5) + t.charAt(e).charCodeAt(0);
    }
    return 2147483647 & n;
};

export const getShow = (id: string) => {
    const url = `${CGI_PATH[GET_SHOW]}?id=${id}&xsrf=${getCookie('TOK')}`;
    return axios.get(url);
};

export const getRoomId = async (id: string): Promise<string> => {
    const url = `${CGI_PATH[GET_SHOW]}?id=${id}&xsrf=${getXSRF()}`;
    return axios.get(url).then((response) => {
        if (response?.data?.retcode === 0) {
            return response?.data?.result?.roomid;
        }
        return '';
    })
        .catch((error) => {
            console.log(error);
            return '';
        });
};

export const getRoomInfo = async (roomId: string): Promise<string> => {
    const url = `${CGI_PATH[GET_ROOM_INFO]}?roomId=${roomId}`;
    return axios.get(url).then((response) => {
        if (response?.data?.retcode === 0) {
            return response?.data?.result?.docid;
        }
        return '';
    })
        .catch((error) => {
            console.error(error);
            return '';
        });
};

export const checkType = (docId: string) => {
    if (config.supportEnterprise(EnterPriseType.ALL)) {
        return axios.get(`${CGI_PATH[GET_DOC_INFO]}?domainId=0&localPadId=${docId}`);
    }

    const urls = `https://${window.hostname}/meeting/${docId}`;
    return axios.get(`${CGI_PATH[DOC_INFOS_GUEST]}?doc_urls=["${urls}"]`);
};

export const getType = () => window?.clientVars?.padType;

export const getUserMarkName = async (
    uidList: Array<string>,
    localPadId: string,
) => {
    if (!localPadId) return;

    // 固定先拉20
    let userInfos = (await getUserInfosByPadID(localPadId, 20))?.userInfos;
    if (!(userInfos && Array.isArray(userInfos))) return null;

    const match = (userInfo, uid) => userInfo.uid === uid || userInfo.reqUid === uid;

    const canFindAll = uidList.every(uid => userInfos?.find(userInfo => match(userInfo, uid)));

    /** 未命中一次拉全量，因为后台逻辑是先从房间层拉全量uid再取count拉详情，全量uid是没有排序的，命中率没法保证。
    后台同学已确认可以拉全量 */
    if (!canFindAll) {
        userInfos = (await getUserInfosByPadID(localPadId))?.userInfos;
        if (!(userInfos && Array.isArray(userInfos))) return null;
    }

    return userInfos.filter(userInfo => uidList.find(uid => match(userInfo, uid)));
};

/**
 * 获取房间层前count个用户的信息.
 * 后台逻辑是先从房间层拉全量uid再取count拉详情，全量uid是没有排序的，命中率没法保证
 */
async function getUserInfosByPadID(padID: string, count = 20) {
    if (!padID) return;

    try {
        const { data } = await axios.get(CGI_PATH[GET_USER_AVATAR_MARKNAME], {
            responseType: 'json',
            withCredentials: true,
            params: {
                bkn: getBkn(),
                xsrf: getXSRF(),

                tag: padID,
                globalPadID: padID,
                count,
            },
        });

        if (data.retcode !== 0) return null;

        return { userInfos: data.result.rsp, totalCount: data.count };
    } catch (error) {
        window.log?.error(error);

        return null;
    }
}
